var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import colors from "../../designSystem/colors";
import { SecondaryText, Title } from "../../designSystem";
import { ActionButton } from "../../components/Common/buttons";
import BasicModal from "./BasicModal";
import { BaseModalContentColumn } from "../../designSystem";
import { useTranslation } from "react-i18next";
var ExternalLinkWarningModal = function (_a) {
    var onClose = _a.onClose, show = _a.show, message = _a.message, continueText = _a.continueText, onContinue = _a.onContinue;
    var t = useTranslation().t;
    return (_jsx(BasicModal, __assign({ show: show, height: 264, maxWidth: 340, onClose: onClose, headerBackground: true }, { children: _jsxs(_Fragment, { children: [_jsx(BaseModalContentColumn, __assign({ marginTop: 8 }, { children: _jsx(Title, { children: t("shared:WarningModal:leavingSite") }, void 0) }), void 0), _jsx(BaseModalContentColumn, __assign({ marginTop: 48, className: "text-align-center" }, { children: _jsx(SecondaryText, __assign({ fontSize: 16, style: {
                            textAlign: "center",
                        } }, { children: message }), void 0) }), void 0), _jsx(ActionButton, __assign({ onClick: onContinue, className: "mt-auto py-3 mb-2", color: colors.green }, { children: continueText }), void 0)] }, void 0) }), void 0));
};
export default ExternalLinkWarningModal;
//# sourceMappingURL=ExternalLinkWarningModal.js.map